import { loaderEnter, loaderLeave } from './loader';
import { introEnter, introLeave } from './intro';
import { pgSelectionEnter, pgSelectionLeave } from './pgSelection';
import {
  tutorialEnter,
  interactionEnter,
  leavesEnter,
  fruitsEnter,
  tutorialPhaseLeave,
  tutorialLeave,
} from './tutorial';
import { gameEnter, gameLeave } from './game';
import { pauseEnter, pauseLeave } from './pause';
import { timeExpiredEnter, timeExpiredLeave } from './timeExpired';
import { gameoverEnter, gameoverLeave } from './gameover';

const transitions = new Map();

transitions.set('loader-enter', loaderEnter);
transitions.set('loader-leave', loaderLeave);
transitions.set('intro-enter', introEnter);
transitions.set('intro-leave', introLeave);
transitions.set('pgSelection-enter', pgSelectionEnter);
transitions.set('pgSelection-leave', pgSelectionLeave);
transitions.set('tutorial-enter', tutorialEnter);
transitions.set('tutorial-interaction-enter', interactionEnter);
transitions.set('tutorial-leaves-enter', leavesEnter);
transitions.set('tutorial-fruits-enter', fruitsEnter);
transitions.set('tutorial-phase-leave', tutorialPhaseLeave);
transitions.set('tutorial-leave', tutorialLeave);
transitions.set('game-enter', gameEnter);
transitions.set('game-leave', gameLeave);
transitions.set('pause-enter', pauseEnter);
transitions.set('pause-leave', pauseLeave);
transitions.set('timeExpired-enter', timeExpiredEnter);
transitions.set('timeExpired-leave', timeExpiredLeave);
transitions.set('gameover-enter', gameoverEnter);
transitions.set('gameover-leave', gameoverLeave);

export default transitions;
